import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { AdminOperationLog } from "../../../../domain/admin_operation_log/AdminOperationLog";

export function useAdminOperationLogList() {
    const { logList } = useSelector((state: State) => state.adminOperationLog);

    return logList.map(logJson => AdminOperationLog.fromJson(logJson));
}
